/**
 * Rendering helpers for the nullable capability fields on `AiModel`.
 *
 * `null` means "unknown" — every model Claude Code already knows ships with
 * null capability fields, and only models it cannot know (e.g. gemma) carry
 * real values. Never render null as a blank cell (reads as a bug) or as
 * `0`/`false` (reads as a real limit of zero) — always this explicit marker.
 */

export const UNKNOWN_MARKER = '—';

export function formatNullableNumber(value: number | null): string {
  return value === null ? UNKNOWN_MARKER : value.toLocaleString('en-US');
}

export function formatNullableBoolean(value: boolean | null): string {
  if (value === null) return UNKNOWN_MARKER;
  return value ? 'Yes' : 'No';
}
